<script>
export default {
  name: 'CpTruncateText',
  directives: {
    marginBottom: require('../directives/margins').marginBottom,
  },
  props: {
    content: { type: String, default: '' },
    enableTruncate: { type: Boolean, default: true },
    lineClamp: { type: Number, default: 3 },
    moreButtonInSameLine: { type: Boolean, default: false },
    withMoreButton: { type: Boolean, default: true },
    textClass: { type: String, default: 'body black-color' },
  },
  data() {
    return {
      isTruncated: true,
      width: 0,
    };
  },
  mounted() {
    const textElement = this.$refs.textContent;
    if (textElement) {
      this.width = textElement.getBoundingClientRect().width;
    }
  },
  computed: {
    numberOfLines() {
      if (!this.width) {
        return 0
      };
      const textElement = this.$refs.textContent;
      if (!textElement) {
        return 0
      };

      const computedStyle = window.getComputedStyle(textElement);
      const lineHeight = parseFloat(computedStyle.lineHeight);
      const textHeight = textElement.scrollHeight;

      if (this.isHTMLContent(this.content)) {
        return this.calculateHeightForHTML(textElement, lineHeight);
      } else {
        return Math.round(textHeight / lineHeight);
      }
    }
  },
  methods: {
    isHTMLContent(content) {
      const div = document.createElement('div');
      div.innerHTML = content;
      return div.getElementsByTagName('*').length > 0;
    },
    calculateHeightForHTML(textElement, lineHeight) {
      const textHeight = textElement.scrollHeight;
      const clientHeight = textElement.clientHeight;
      const lines = Math.round(textHeight / lineHeight);

      if (textHeight > clientHeight) {
        const extraLines = Math.floor(textHeight / lineHeight);
        return lines + extraLines;
      } else {
        return 0
      }
    },
    handleTruncateContent() {
      this.isTruncated = !this.isTruncated;
    },
  },
};
</script>
<template>
  <div class="text-container" :class="{ 'more-button-in-same-line': moreButtonInSameLine }">
    <span
      ref="textContent"
      :class="[textClass, { 'truncate-text': enableTruncate && isTruncated }]"
      :style="isTruncated ? { '-webkit-line-clamp': lineClamp } : {}"
      v-html="content"
      v-margin-bottom="0"
    />
    <span v-if="withMoreButton && enableTruncate && isTruncated && numberOfLines > lineClamp" @click="handleTruncateContent" class="body primary-color more-button"> (more) </span>
  </div>
</template>

<style scoped>
.truncate-text {
  display: -webkit-box;
  line-clamp: var(--line-clamp, 3);
  -webkit-line-clamp: var(--line-clamp, 3);
  -webkit-box-orient: vertical;
  -webkit-box-pack: end;
  text-overflow: ellipsis;
  overflow: hidden;
}
.text-container {
  overflow: hidden;
}
.text-container.more-button-in-same-line {
  display: flex;
  align-items: center;
}
.more-button {
  cursor: pointer;
}
.text-container >>> figure,
.text-container ::v-deep figure {
  max-width: 50%;
  margin: 0.5em auto;
  display: block;
}

.text-container >>> figure img,
.text-container ::v-deep figure img {
  width: 100%;
  height: auto;
  display: block;
}
@media (max-width: 1000px) {
  .text-container >>> figure,
  .text-container ::v-deep figure {
    max-width: 75%;
  }
}
@media (max-width: 768px) {
  .text-container >>> figure,
  .text-container ::v-deep figure {
    max-width: 100%;
  }
}
</style>
